var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conteiner text-center pt-5"},[_c('img',{attrs:{"round":"","width":"120","src":require("@/assets/img/logo.png"),"alt":""}}),_c('br'),_c('br'),_c('br'),_c('h1',[_vm._v("404 :((")]),_c('h4',[_c('a',{attrs:{"href":"/"}},[_vm._v("Домой")])])])
}]

export { render, staticRenderFns }